import { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPhp, faReact, faJs, faHtml5, faCss3Alt, faGithub, faAndroid, faFigma
} from '@fortawesome/free-brands-svg-icons';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import GlareHover from '../glareHover/GlareHover';
import './Skills.css';

const skills = [
    { name: "PHP", icon: faPhp },
    { name: "React", icon: faReact },
    { name: "JavaScript", icon: faJs },
    { name: "HTML", icon: faHtml5 },
    { name: "CSS", icon: faCss3Alt },
    { name: "SQL", icon: faDatabase },
    { name: "Android Studio", icon: faAndroid },
    { name: "GitHub", icon: faGithub },
    { name: "Figma", icon: faFigma },
];

const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.1 } }
};

const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

export default function Skills({ id }) {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    const [lineVisible, setLineVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setTimeout(() => setLineVisible(true), 100);
                    setTimeout(() => setVisible(true), 300);
                }
            },
            { threshold: 0.1 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="skills-container" id={id} ref={sectionRef}>

            <div className={`section-label ${visible ? 'section-label--visible' : ''}`}>
                <span>03</span>
                <span>TECNOLOGIAS</span>
            </div>

            <div className={`section-line ${lineVisible ? 'section-line--visible' : ''}`} />

            <div className="skills-header">
                <h2 className={`section-title ${visible ? 'section-title--visible' : ''}`}>
                    <span>O meu</span>
                    <span className="text-outline">stack.</span>
                </h2>
                <p className={`skills-subtitle ${visible ? 'skills-subtitle--visible' : ''}`}>
                    Tecnologias que utilizei em projetos académicos e pessoais.
                </p>
            </div>

            <motion.div
                className="cards-container"
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                {skills.map((skill, index) => (
                    <GlareHover
                        key={index}
                        glareColor="#ffffff"
                        glareOpacity={0.3}
                        glareAngle={-30}
                        glareSize={300}
                        transitionDuration={800}
                        playOnce={false}
                    >
                        <motion.div className="skill-card" variants={cardVariants}>
                            <FontAwesomeIcon icon={skill.icon} size="3x" />
                            <h3>{skill.name}</h3>
                        </motion.div>
                    </GlareHover>
                ))}
            </motion.div>

            <div className={`section-line section-line--bottom ${lineVisible ? 'section-line--visible' : ''}`} />
        </div>
    );
}